/**
 * 通达信内置浏览器联动工具
 */

/**
 * 触发通达信联动跳转
 * @param {string} symbolCode 股票代码，格式如 "002222.SZ" 或 "601869.SH"
 */
export function tdxLinkStock(symbolCode) {
    if (!symbolCode) return;
    
    try {
        // 检测是否在通达信内置浏览器中
        const isTdx = /Tdx/i.test(navigator.userAgent);
        if (isTdx) {
            const parts = symbolCode.split('.');
            const code = parts[0];
            const suffix = parts[1] || '';
            
            let market = '0'; // 默认深市
            if (suffix === 'SH') market = '1';
            else if (suffix === 'BJ') market = '2';
            
            // 使用隐藏 iframe 触发，避免主页面跳转/刷新
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = `http://www.treeid/code=${code}&market=${market}`;
            document.body.appendChild(iframe);
            
            // 延时移除
            setTimeout(() => {
                if (document.body.contains(iframe)) {
                    document.body.removeChild(iframe);
                }
            }, 1000);
            
            console.log(`[TdxLink] Linked to ${code} (Market: ${market})`);
        }
    } catch (e) {
        console.error('[TdxLink] Linkage failed:', e);
    }
}
